import { createFileRoute, Link } from "@tanstack/react-router";
import { PostEditor } from "@/components/admin/PostEditor";

export const Route = createFileRoute("/_authenticated/admin/blog/$id")({
  component: EditPostPage,
});

function EditPostPage() {
  const { id } = Route.useParams();
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold text-foreground">Edit post</h1>
        <Link to="/admin/blog" className="text-sm text-muted-foreground hover:text-foreground">← Back to posts</Link>
      </div>
      <PostEditor postId={id} />
    </div>
  );
}